import { render, staticRenderFns } from "./OneIconLoader.vue?vue&type=template&id=e6823fa0&scoped=true&lang=pug&"
import script from "./OneIconLoader.vue?vue&type=script&lang=ts&"
export * from "./OneIconLoader.vue?vue&type=script&lang=ts&"
import style0 from "./OneIconLoader.vue?vue&type=style&index=0&id=e6823fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6823fa0",
  null
  
)

export default component.exports